export enum CreditType {
  ENTRY_CREDIT,
  FILL_CREDIT,
  DAILY_REVAL_CREDIT,
  PROXIMITY_REVAL_CREDIT,
  MODIFY_CREDIT,
  ENTRY_PROXIMITY_CREDIT,
  MODIFY_PROXIMITY_CREDIT,
  CANCEL_CREDIT,
  EXPIRY_CREDIT,
  REJECTED_CREDIT,
}

export namespace CreditType {
  let elements = [
    CreditType.ENTRY_CREDIT,
    CreditType.FILL_CREDIT,
    CreditType.DAILY_REVAL_CREDIT,
    CreditType.PROXIMITY_REVAL_CREDIT,
    CreditType.MODIFY_CREDIT,
    CreditType.ENTRY_PROXIMITY_CREDIT,
    CreditType.MODIFY_PROXIMITY_CREDIT,
    CreditType.CANCEL_CREDIT,
    CreditType.EXPIRY_CREDIT,
    CreditType.REJECTED_CREDIT,
  ];
  let alias = "com.bcdfx.model.CreditType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
